// src/components/home/TestimonialsSection.jsx
import React from 'react';

// Patient images
import patient1 from '../../assets/student1.png';
import patient2 from '../../assets/student2.png';
import patient3 from '../../assets/student3.png';

const TestimonialsSection = () => {
  const testimonials = [
    {
      quote:
        "I had been struggling with joint pain for years, and after taking Ayurvedic treatments here, I feel a remarkable improvement. The therapies are natural, safe, and truly effective. I’m grateful to the doctors and staff for their care.",
      name: "Ramesh K.",
      color: "#f36c45",
      photo: patient1,
    },
    {
      quote:
        "The therapies, herbal supplements, and yoga sessions helped me regain balance in both body and mind. Unlike other treatments, Ayurveda healed me from the root. I highly recommend this hospital for natural healing.",
      name: "Anjali P.",
      color: "#4aa52e",
      photo: patient2,
    },
    {
      quote:
        "The personalized consultation and treatment plan made a big difference in my health journey. I not only recovered from my digestive issues but also learned how to maintain a healthier lifestyle with Ayurveda.",
      name: "Suresh M.",
      color: "#2ca8b1",
      photo: patient3,
    },
  ];

  return (
    <section className="bg-[#E4DED5] text-center py-16 sm:py-20 px-4 sm:px-6 md:px-16 font-poppins">
  {/* Header */}
  <div className="mb-10 sm:mb-14 px-2">
    <button className="inline-block text-[#0B2A2C] px-4 sm:px-6 py-2 rounded-full text-xl font-medium mb-4 sm:mb-6 border border-[#0B2A2C]">
       Testimonials
    </button>
    <h2 className="text-[black] text-3xl sm:text-4xl md:text-5xl font-playfair font-semibold mt-4 sm:mt-5 mb-2">
      What our patients say
    </h2>
    <p className="text-[#4b4b4b] text-sm sm:text-base md:text-lg px-2">
      Hear from those who’ve rediscovered wellness through Ayurveda
    </p>
  </div>
  {/* Testimonials Cards - Flex with wrap, responsive widths */}
  <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-6 sm:gap-8 md:gap-10 px-2">
  {/* Card 1 */}
  <div className="relative bg-[#FBF4E7] w-full sm:w-[340px] md:w-[360px] rounded-2xl shadow-md p-6 sm:p-8 text-left transition-transform duration-300 hover:-translate-y-1 overflow-hidden mx-auto sm:mx-0">
    {/* Closing quote (rotated) on top */}
    <svg
      className="absolute top-4 sm:top-6 left-4 sm:left-5 text-[#f36c45] w-6 h-6 sm:w-8 sm:h-8 rotate-180"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M9.5 3C6.46 3 4 5.46 4 8.5S6.46 14 9.5 14c.27 0 .53-.02.78-.06C10.1 15.72 8.32 17 6 17v4c4.42 0 8-3.58 8-8V8.5C14 5.46 11.54 3 8.5 3zM19.5 3C16.46 3 14 5.46 14 8.5S16.46 14 19.5 14c.27 0 .53-.02.78-.06C20.1 15.72 18.32 17 16 17v4c4.42 0 8-3.58 8-8V8.5C24 5.46 21.54 3 18.5 3z" />
    </svg>
    <p className="relative text-[#6f665c] italic leading-relaxed mt-8 sm:mt-10 mb-8 sm:mb-12 z-10 px-1">
      “I had been struggling with joint pain for years, and after taking Ayurvedic treatments here, I feel a remarkable improvement. The therapies are natural, safe, and truly effective. I’m grateful to the doctors and staff for their care.”
    </p>
    {/* Opening quote on bottom */}
    <svg
      className="absolute bottom-8 sm:bottom-10 right-4 sm:right-6 text-[#f36c45] w-6 h-6 sm:w-8 sm:h-8"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M9.5 3C6.46 3 4 5.46 4 8.5S6.46 14 9.5 14c.27 0 .53-.02.78-.06C10.1 15.72 8.32 17 6 17v4c4.42 0 8-3.58 8-8V8.5C14 5.46 11.54 3 8.5 3zM19.5 3C16.46 3 14 5.46 14 8.5S16.46 14 19.5 14c.27 0 .53-.02.78-.06C20.1 15.72 18.32 17 16 17v4c4.42 0 8-3.58 8-8V8.5C24 5.46 21.54 3 18.5 3z" />
    </svg>
    <div className="flex items-center gap-2 sm:gap-3 z-10 relative">
      <img
        src={patient1}
        alt="Ramesh K."
        className="w-8 h-8 sm:w-12 sm:h-12 rounded-full object-cover"
      />
      <span className="font-medium text-sm sm:text-base text-[#f36c45]">– Ramesh K.</span>
    </div>
  </div>
  {/* Card 2 */}
  <div className="relative bg-[#FBF4E7] w-full sm:w-[340px] md:w-[360px] rounded-2xl shadow-md p-6 sm:p-8 text-left transition-transform duration-300 hover:-translate-y-1 overflow-hidden mx-auto sm:mx-0">
    <svg
      className="absolute top-4 sm:top-6 left-4 sm:left-5 text-[#4aa52e] w-6 h-6 sm:w-8 sm:h-8 rotate-180"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M9.5 3C6.46 3 4 5.46 4 8.5S6.46 14 9.5 14c.27 0 .53-.02.78-.06C10.1 15.72 8.32 17 6 17v4c4.42 0 8-3.58 8-8V8.5C14 5.46 11.54 3 8.5 3zM19.5 3C16.46 3 14 5.46 14 8.5S16.46 14 19.5 14c.27 0 .53-.02.78-.06C20.1 15.72 18.32 17 16 17v4c4.42 0 8-3.58 8-8V8.5C24 5.46 21.54 3 18.5 3z" />
    </svg>
    <p className="relative text-[#6f665c] italic leading-relaxed mt-8 sm:mt-10 mb-8 sm:mb-12 z-10 px-1">
      “The therapies, herbal supplements, and yoga sessions helped me regain balance in both body and mind. Unlike other treatments, Ayurveda healed me from the root. I highly recommend this hospital for natural healing.”
    </p>
    <svg
      className="absolute bottom-8 sm:bottom-10 right-4 sm:right-6 text-[#4aa52e] w-6 h-6 sm:w-8 sm:h-8"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M9.5 3C6.46 3 4 5.46 4 8.5S6.46 14 9.5 14c.27 0 .53-.02.78-.06C10.1 15.72 8.32 17 6 17v4c4.42 0 8-3.58 8-8V8.5C14 5.46 11.54 3 8.5 3zM19.5 3C16.46 3 14 5.46 14 8.5S16.46 14 19.5 14c.27 0 .53-.02.78-.06C20.1 15.72 18.32 17 16 17v4c4.42 0 8-3.58 8-8V8.5C24 5.46 21.54 3 18.5 3z" />
    </svg>
    <div className="flex items-center gap-2 sm:gap-3 z-10 relative">
      <img
        src={patient2}
        alt="Suresh M."
        className="w-8 h-8 sm:w-12 sm:h-12 rounded-full object-cover"
      />
      <span className="font-medium text-sm sm:text-base text-[#4aa52e]">– Anjali P.</span>
    </div>
  </div>
  {/* Card 3 */}
  <div className="relative bg-[#FBF4E7] w-full sm:w-[340px] md:w-[360px] rounded-2xl shadow-md p-6 sm:p-8 text-left transition-transform duration-300 hover:-translate-y-1 overflow-hidden mx-auto sm:mx-0">
    <svg
      className="absolute top-4 sm:top-6 left-4 sm:left-5 text-[#2ca8b1] w-6 h-6 sm:w-8 sm:h-8 rotate-180"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M9.5 3C6.46 3 4 5.46 4 8.5S6.46 14 9.5 14c.27 0 .53-.02.78-.06C10.1 15.72 8.32 17 6 17v4c4.42 0 8-3.58 8-8V8.5C14 5.46 11.54 3 8.5 3zM19.5 3C16.46 3 14 5.46 14 8.5S16.46 14 19.5 14c.27 0 .53-.02.78-.06C20.1 15.72 18.32 17 16 17v4c4.42 0 8-3.58 8-8V8.5C24 5.46 21.54 3 18.5 3z" />
    </svg>
    <p className="relative text-[#6f665c] italic leading-relaxed mt-8 sm:mt-10 mb-8 sm:mb-12 z-10 px-1">
      “The personalized consultation and treatment plan made a big difference in my health journey. I not only recovered from my digestive issues but also learned how to maintain a healthier lifestyle with Ayurveda.”
    </p>
    <svg
      className="absolute bottom-8 sm:bottom-10 right-4 sm:right-6 text-[#2ca8b1] w-6 h-6 sm:w-8 sm:h-8"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M9.5 3C6.46 3 4 5.46 4 8.5S6.46 14 9.5 14c.27 0 .53-.02.78-.06C10.1 15.72 8.32 17 6 17v4c4.42 0 8-3.58 8-8V8.5C14 5.46 11.54 3 8.5 3zM19.5 3C16.46 3 14 5.46 14 8.5S16.46 14 19.5 14c.27 0 .53-.02.78-.06C20.1 15.72 18.32 17 16 17v4c4.42 0 8-3.58 8-8V8.5C24 5.46 21.54 3 18.5 3z" />
    </svg>
    <div className="flex items-center gap-2 sm:gap-3 z-10 relative">
      <img
        src={patient3}
        alt="Anjali P."
        className="w-8 h-8 sm:w-12 sm:h-12 rounded-full object-cover"
      />
      <span className="font-medium text-sm sm:text-base text-[#2ca8b1]">– Suresh M.</span>
    </div>
  </div>
</div>
  {/* Footer */}
  {/* <div className="mt-8 sm:mt-10 text-[#7e7e7e] text-xs sm:text-sm md:text-base flex justify-center items-center gap-1 px-2">
    <span>See More</span>
            <span className="arrow">»</span>
  </div> */}
</section>
  );
};

export default TestimonialsSection;